import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "ec-6a70e926-9f70-424e-ae95-9578459b1839-__Layer_1",
  "enable-background": "new 0 0 128 128",
  height: "48px",
  viewBox: "0 0 1024 1024",
  width: "48px",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "ec-a52745bf-a8d2-49ae-a687-0dc80dd65b47-__Down_Arrow_3_",
      d: "M 512.002 791.274 C 500.098 791.274 488.182 786.724 479.094 777.636 L 13.64 312.183 C -4.547 293.995 -4.547 264.543 13.64 246.367 C 31.828 228.191 61.28 228.18 79.456 246.367 L 512.002 678.914 L 944.548 246.367 C 962.736 228.18 992.187 228.18 1010.363 246.367 C 1028.539 264.555 1028.551 294.007 1010.363 312.183 L 544.91 777.636 C 535.822 786.724 523.906 791.274 512.002 791.274 Z"
    }, null, -1)
  ]))]))
}
export default { render: render }